import React from 'react';
import Icon from './Icon';

const SIZES = {
  sm: 'h-8 px-3 text-[13px] rounded-lg gap-1.5',
  md: 'h-10 px-4 text-sm rounded-lg gap-2',
  lg: 'h-11 px-5 text-[15px] rounded-xl gap-2',
};

const TONES = {
  primary: 'bg-leaf-600 hover:bg-leaf-700 text-white shadow-soft',
  navy:    'bg-ink-700 hover:bg-ink-800 text-white shadow-soft',
  ghost:   'bg-transparent hover:bg-ink-50 text-ink-700',
  outline: 'bg-white hover:bg-paper-100 text-ink-800 ring-1 ring-ink-200',
  danger:  'bg-flame-500 hover:bg-flame-600 text-white shadow-soft',
  link:    'text-leaf-700 hover:text-leaf-800 underline-offset-2 hover:underline',
};

/**
 * Unified button component.
 *
 * Props:
 *   tone     – 'primary' | 'navy' | 'ghost' | 'outline' | 'danger' | 'link'
 *   size     – 'sm' | 'md' | 'lg'
 *   icon     – leading Icon name
 *   trailing – trailing Icon name
 */
const Btn = ({ tone = 'primary', size = 'md', icon, trailing, children, className = '', ...props }) => {
  const iconSize = size === 'sm' ? 14 : 16;
  return (
    <button
      className={`inline-flex items-center justify-center font-medium transition-colors ${SIZES[size] || SIZES.md} ${TONES[tone] || TONES.primary} ${className}`}
      {...props}
    >
      {icon && <Icon name={icon} size={iconSize} />}
      {children}
      {trailing && <Icon name={trailing} size={iconSize} />}
    </button>
  );
};

export default Btn;
